<template>
  <div>
    <v-card>
      <v-card-title class="footer">
        {{ title }} &nbsp;
        <v-icon v-if="title.includes('failed')" color="error">
          mdi-alert-box</v-icon
        >
        <v-icon v-if="title.includes('Successfully')" color="success"
          >mdi-check-outline</v-icon
        >
      </v-card-title>
      <v-card-text>
        <v-data-table
          class="mt-6"
          :headers="headers"
          :items="products"
          item-key="SKU"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
          :search="search"
          dense
          :no-data-text="'No products were found...'"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200],
          }"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
              outlined
              dense
            ></v-text-field>
          </template>
          <template v-slot:[`item.Photos`]="{ item }">
            <tr v-for="(itm, p) in item.Photos" :key="p">
              <td v-if="p === 0">
                <v-img max-width="50px" :src="itm"></v-img>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ProductInfo :product="item"></ProductInfo>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ProductInfo from "../organisms/ProductInfo.vue";

export default {
  name: "UploadedItemsList",
  props: {
    products: Array,
    title: String,
    icon: String,
  },
  components: {
    ProductInfo,
  },
  data: () => ({
    headers: [
      { text: "Photo", value: "Photos" },
      { text: "Custom label", value: "SKU" },
      { text: "Barcode", value: "Barcode" },
      { text: "Category", value: "Category" },
      { text: "Condition", value: "Condition" },
      { text: "Brand", value: "Brand" },
      { text: "RRP", value: "RRP" },
      { text: "Currency", value: "Currency" },
      { text: "Stock", value: "stock" },
    ],
    search: "",
    expanded: [],
  }),
  computed: {},
  methods: {},
};
</script>